import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import type { DetailItemCardVariant } from '../common/types'

import type {
  CruiseItem,
  TourItem,
} from 'tripPlanner/types/tripItem'
import TourCTAContent from '../CTAContent/TourCTAContent'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import LEOfferPriceDetails from 'tripPlanner/components/ItemOfferPrice/LEOfferPriceDetails'

interface Props {
  item: Utils.RequiredProp<TourItem, 'savedItemData'> | Utils.RequiredProp<CruiseItem, 'savedItemData'>
  offer: App.TourOffer
  variant: DetailItemCardVariant
}

function TourV1PriceAndCTAs({ item, offer, variant }: Props) {
  if (item.isSuggested) {
    // We don't currently do suggested tours. If we ever do, update this.
    return null
  }

  const offerLink = buildProductLink(item, { offer }) ?? ''

  const { savedItemData } = item

  const packageId = 'packageId' in savedItemData ? offer.packages.find(
    (p) => p.id === savedItemData.packageId,
  ) : undefined

  const priceAreaContent =
    <LEOfferPriceDetails
      offer={offer}
      package={packageId}
    />

  const ctaAreaContent = (
    <TourCTAContent
      item={item}
      isOfferAvailable
      variant={variant}
      offerLink={offerLink}
    />
  )

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default TourV1PriceAndCTAs
